import { jsx as d } from "react/jsx-runtime";
import { forwardRef as D, useRef as M, useMemo as r } from "react";
import { useMultiStyleConfig as T, useMergeRefs as v, Box as w } from "@chakra-ui/react";
import { Typography as A } from "../../dataDisplay/Typography/Typography.mjs";
import { useAutoSuggestionContext as C } from "./useAutoSuggestionContext.mjs";
import { getSuggestionDisplayValue as F } from "./autoSuggestionFunctions.mjs";
const I = D((f, m) => {
  const o = M(null), { suggestionIndex: e, ...p } = f, {
    dataTestId: u,
    handleSelection: S,
    id: y,
    keyedSuggestion: t,
    renderOption: s,
    options: n,
    handleSuggestionFocus: x
  } = C(), h = T("AutoSuggestion"), { value: g, suggestion: a } = n[e], i = r(
    () => F(g, a),
    [g, a]
  ), l = r(() => (t === e && o.current && x(o.current), t === e), [t, e]), R = r(
    () => s ? s(n[e]) : /* @__PURE__ */ d(A, { children: i }),
    [s, n[e], i]
  ), $ = v(o, m);
  return /* @__PURE__ */ d(
    w,
    {
      ref: $,
      role: "option",
      id: `${y}-suggestion-${e}`,
      "data-testid": u && `${u}-suggestion-${e}`,
      "aria-selected": l,
      "aria-label": `Suggestion - ${i}.`,
      onMouseDown: (c) => {
        c.preventDefault(), S(c);
      },
      sx: h.suggestion,
      ...l && { className: "suggestion-focused" },
      ...p,
      children: R
    }
  );
});
I.displayName = "Suggestion";
export {
  I as Suggestion
};
